var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFinetuneParametersNoVoice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M6 8.667a2.666 2.666 0 1 0 0-5.334 2.666 2.666 0 1 0 0 5.334m0-4c.733 0 1.333.6 1.333 1.333S6.733 7.333 6 7.333 4.667 6.733 4.667 6 5.267 4.667 6 4.667M6 10c-1.78 0-5.333.893-5.333 2.667V14h10.666v-1.333C11.333 10.893 7.78 10 6 10m-4 2.667c.147-.48 2.207-1.334 4-1.334 1.8 0 3.867.86 4 1.334z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B7B7C2",
  d: "m14.333 3-.667-.667L12 4l-1.667-1.667L9.666 3l1.667 1.667-1.667 1.666.667.667L12 5.333 13.666 7l.667-.667-1.666-1.666z"
})));
export default SvgFinetuneParametersNoVoice;